
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 2.5H4.005a1 1 0 000 1.998h9.997A1 1 0 1014 2.5zM2.005 3.499a1 1 0 00-2 0 .851.851 0 000 .195.901.901 0 00.15.36.915.915 0 00.275.274c.053.039.11.07.17.095.067.035.137.06.21.075.065.008.13.008.195 0a1 1 0 00.925-.614.928.928 0 00.075-.19.852.852 0 000-.195zM2.005 7.997a.855.855 0 000-.195.81.81 0 00-.075-.185 1 1 0 00-.22-.325 1 1 0 00-1.54 1.26.96.96 0 00.13.15.73.73 0 00.15.125.85.85 0 00.36.15.83.83 0 00.195.02c.065.007.13.007.195 0a.812.812 0 00.185-.055.835.835 0 00.175-.095.73.73 0 00.15-.125.73.73 0 00.125-.15.804.804 0 00.095-.17.846.846 0 00.075-.21.827.827 0 000-.195zM2.005 12.496a.86.86 0 000-.195.851.851 0 00-.075-.19 1.156 1.156 0 00-.095-.17 1 1 0 00-1.66 0 .818.818 0 00-.15.36 1 1 0 00.275.9c.045.047.095.09.15.124a.849.849 0 00.36.15c.064.015.13.021.195.02.065.008.13.008.195 0a.812.812 0 00.185-.055.833.833 0 00.175-.095.731.731 0 00.15-.125.732.732 0 00.125-.15.801.801 0 00.095-.17.848.848 0 00.075-.21.827.827 0 000-.194zM15 6.998H4.004a1 1 0 000 1.999H15a1 1 0 000-2zM10.502 11.496H4.004a1 1 0 100 2h6.498a1 1 0 000-2z","fill":"currentColor"}})])
          )
        }
      }
    